// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"ageverifCloseButton-module__closeButton___wx26j"};